import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { csvDownloadServices } from 'src/app/services/csv-download.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JwtService } from 'src/app/services/jwt.service';
import * as moment from 'moment';
import { MixpanelService } from 'src/app/services/mixpanel.service';


@Component({
  selector: 'app-activity-log',
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.css'],
})
export class ActivityLogComponent implements OnInit {

  loaded = false;
  activityList: any;
  activityDate: any[] = [];
  fromDate: Date;
  toDate: Date;
  listData: any;
  currDate: Date;
  constructor(
    private exportFile: csvDownloadServices,
    private api: ApiService,
    private snackbar: MatSnackBar,
    private jwt: JwtService,
    private mixpanel: MixpanelService
  ) {
    this.currDate = new Date();
  }

  ngOnInit(): void {
    this.mixpanel.track("page_view", { page: "Activity Log", category: "Dashboard", button: "-"  })
    this.jwt.check();
    let param = {
      fromDate: '',
      toDate: '',
    };
    this.getData(param);
  }

  reset() {
    this.fromDate = null;
    this.toDate = null;
    let param = {
      fromDate: '',
      toDate: '',
    };
    this.getData(param);
  }

  getDateAsApiFormat(e) {
    e = new Date(e);
    return `${e.getFullYear()}-${this.twoDigit(
      e.getMonth() + 1)}-${this.twoDigit(e.getDate())}`;
  }

  onDateChanged() {
    if (this.fromDate && this.toDate) {
      if (this.fromDate > this.toDate) {
        this.fromDate = null;
        this.toDate = null;
        this.snackbar.open(
          'From Date should not be exceed To Date',
          undefined,
          {
            duration: 5000,
            panelClass: 'failure',
          }
        );
        return;
      }
      let todayMinus90 = new Date(this.toDate);
      todayMinus90.setDate(todayMinus90.getDate() - 90);
      if (this.fromDate < todayMinus90) {
        this.fromDate = null;
        this.toDate = null;
        this.snackbar.open('Only 3 months data can be viewed', undefined, {
          duration: 5000,
          panelClass: 'failure',
        });
        return;
      }
      let param = {
        fromDate: this.getDateAsApiFormat(this.fromDate),
        toDate: this.getDateAsApiFormat(this.toDate),
      };
      this.getData(param);
    }
  }

  getData(param) {
    this.loaded = false;
    this.api.logs(param).subscribe((data: any) => {
      if (data.status) {
        this.listData = data.data;
        this.activityList = this.listData.rows;
        this.activityDate = [];
        for (let Key in this.activityList) {
          this.activityDate.push(Key);
        }
        this.loaded = true;
      } else {
        this.loaded = true;
        this.snackbar.open(data.message, undefined, {
          duration: 5000,
          panelClass: 'failure',
        });
      }
    },
    ( error ) => {
      this.loaded = true;
    });
  }

  fileLink( link ) {
    window.open( link );
  }

  onExport() {
    this.mixpanel.track("button_click", { page: "Activity Log", category: "Dashboard", button: "Export" })
    let list = [];
    this.activityDate.forEach((element) => {
      list.push(...this.activityList[element]);
    });
    if (list.length == 0) {
      return;
    }
    let exportList = [];
    list.forEach((element) => {
      let x = {};
      for (let key in this.listData.header) {
        if (Object.keys(element).includes(key)) {
          x[this.listData.header[key]] = element[key];
          if (typeof list[`_${key}`] === 'object') {
          }
          if( key === 'fileLink') {
            x[this.listData.header[key]] = element[key] ? element[key].toString() : "";
          }
        }
      }
      exportList.push(x);
    });
    const spacing = [
      { wch: 30 },
      { wch: 30 },
      { wch: 20 },
      { wch: 20 },
      { wch: 30 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
    ];
    this.exportFile.exportArrayToExcel(
      exportList,
      'Activity List ' + new Date(),
      spacing
    );
  }

  twoDigit(e) {
    return String(
      Number(e).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })
    );
  }

  _date( date ) {
    return moment.utc(date).local().format();
  }
}
